import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
// import { apiClient_New } from '@/plugins/apiClient';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    /*const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }*/
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  dashboard115: null,
  dashboard800: null,
  dashboardDoctor: null,
  dashboardAdmission: null,
  dashboardQC: null,
  dashboardQCUser115: null,
  dashboardQCUser800: null,
  dashboardQCUserTechnician: null,
  dashboardQCUserDoctor: null,
  dashboardQCUserAdmission: null,
  dashboardQCCheckList: null,
  dashboardStatisticsMain: null,

  dashboardMain115: null,
  dashboardMain800: null,
  numberOfCurrentMissions: null,
  vehiclesReadiness: null,
  awaitingMissions: null,
  currentMissionsByRank: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_18: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_115Dashboard(state, dashboards) {
    state.dashboard115 = dashboards;
  },
  SET_800Dashboard(state, dashboards) {
    state.dashboard800 = dashboards;
  },
  SET_DoctorDashboard(state, dashboards) {
    state.dashboardDoctor = dashboards;
  },
  SET_AdmissionDashboard(state, dashboards) {
    state.dashboardAdmission = dashboards;
  },
  SET_QCDashboard(state, dashboards) {
    state.dashboardQC = dashboards;
  },
  SET_QCUser115Dashboard(state, dashboards) {
    state.dashboardQCUser115 = dashboards;
  },
  SET_QCUser800Dashboard(state, dashboards) {
    state.dashboardQCUser800 = dashboards;
  },
  SET_QCUserTechnicianDashboard(state, dashboards) {
    state.dashboardQCUserTechnician = dashboards;
  },
  SET_QCUserDoctorDashboard(state, dashboards) {
    state.dashboardQCUserDoctor = dashboards;
  },
  SET_QCUserAdmissionDashboard(state, dashboards) {
    state.dashboardQCUserAdmission = dashboards;
  },
  SET_QCCheckListDashboard(state, dashboards) {
    state.dashboardQCCheckList = dashboards;
  },
  SET_StatisticsMainDashboard(state, dashboards) {
    state.dashboardStatisticsMain = dashboards;
  },

  SET_115DashboardMain(state, dashboards) {
    state.dashboardMain115 = dashboards;
  },
  SET_800DashboardMain(state, dashboards) {
    state.dashboardMain800 = dashboards;
  },
  SET_NumberOfCurrentMissionsDashboard(state, data) {
    state.numberOfCurrentMissions = data;
  },
  SET_VehiclesReadinessDashboard(state, data) {
    state.vehiclesReadiness = data;
  },
  SET_AwaitingMissionsDashboard(state, data) {
    state.awaitingMissions = data;
  },
  SET_CurrentMissionsByRankDashboard(state, data) {
    state.currentMissionsByRank = data;
  },
};
const actions = {
  errorDashboard({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getDashboard115({ commit, dispatch, rootState }) {
    // return apiClient_New
    return apiClient
      .get('/Dashboards/User115', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_115Dashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getDashboard800({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/User800', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_800Dashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getDashboardDoctor({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/UserDoctor', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DoctorDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getDashboardAdmission({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/UserAdmission', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AdmissionDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getDashboardQC({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Dashboards/QCMain', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then((response) => {
        commit('SET_QCDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getQcUser115Dashboard({ commit, dispatch, rootState }, { fromDate, toDate, userId }) {
    let url = '/Dashboards/QCUser115?UserId=' + userId;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCUser115Dashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getQcUser800Dashboard({ commit, dispatch, rootState }, { fromDate, toDate, userId }) {
    let url = '/Dashboards/QCUser800?UserId=' + userId;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCUser800Dashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getQcUserTechnicianDashboard({ commit, dispatch, rootState }, { fromDate, toDate, userId }) {
    let url = '/Dashboards/QCUserTechnician?UserId=' + userId;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCUserTechnicianDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getQcUserDoctorDashboard({ commit, dispatch, rootState }, { fromDate, toDate, userId }) {
    let url = '/Dashboards/QCUserDoctor?UserId=' + userId;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCUserDoctorDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getQcUserAdmissionDashboard({ commit, dispatch, rootState }, { fromDate, toDate, userId }) {
    let url = '/Dashboards/QCUserAdmission?UserId=' + userId;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCUserAdmissionDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getQCCheckListDashboard({ commit, dispatch, rootState }, { fromDate, toDate, userId }) {
    let url = '/Dashboards/QCCheckList';
    if (userId || fromDate || toDate) {
      url += '?';
    }
    if (userId) {
      url += '&UserId=' + userId;
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCCheckListDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getStatisticsMainDashboard({ commit, dispatch, rootState }, { fromDate, toDate }) {
    let url = '/Dashboards/StatisticsMain';
    if (fromDate) {
      url += '?FromDate=' + fromDate;
      if (toDate) {
        url += '&ToDate=' + toDate;
      }
    } else if (toDate) {
      url += '?ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_StatisticsMainDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },

  getDashboardMain115({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/MainDashboard115', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_115DashboardMain', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getDashboardMain800({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/Main800', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_800DashboardMain', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getNumberOfCurrentMissionsDashboard({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/NumberOfCurrentMissions', { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_NumberOfCurrentMissionsDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getVehiclesReadinessDashboard({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/VehiclesReadiness', { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_VehiclesReadinessDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getAwaitingMissionsDashboard({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/AwaitingMissions', { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AwaitingMissionsDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
  getCurrentMissionsByRankDashboard({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Dashboards/CurrentMissionsByRank', { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_CurrentMissionsByRankDashboard', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDashboard', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
